// extracted by mini-css-extract-plugin
export var iconHe = "pageJoin-module--iconHe--0H23U";
export var iconFace = "pageJoin-module--iconFace--dGtlx";
export var iconHand = "pageJoin-module--iconHand--AjQ3v";